// core/content/ContentLoader.js
export default class ContentLoader {
	constructor({ swup }) {
		this.swup = swup
	}

	async load(url) {
		console.log(`Loading content for ${url}`)
		// 1. Check Swup cache first
		const cached = this.swup?.cache?.get(url)
		if (cached) {
			return this.extractContent(cached.html)
		}

		// 2. Ask Swup to preload (this also caches)
		if (this.swup) {
			const page = await this.swup.preload(url)
			return this.extractContent(page.html)
		}

		// 3. Fallback (no Swup)
		const res = await fetch(url)
		const html = await res.text()
		return this.extractContent(html)
	}

	extractContent(html) {
		const dom = new DOMParser().parseFromString(html, 'text/html')

		// 🔴 IMPORTANT: single, explicit extraction point
		const article = dom.querySelector('[data-view-content]')
		return article ? article.outerHTML : ''
	}
}
